import { useEffect, useMemo } from 'react';
import {
  ElectronicIdHubServiceEvents,
  ElectronicIdHubServiceToken,
  type AudkenniAppHubData,
  type ElectronicIdHubData,
  type IElectronicIdHubService,
  type OnReceiveErrorCallback,
  type OnReceiveSuccessCallback,
  type OnReceiveVerificationDataCallback,
} from 'src/services/ElectronicIdHubService';
import { HubServiceEvents } from 'src/services/HubService';
import { ServicesProvider } from 'src/services/ServicesProvider';

export type UseElectronicIdHubSubscriber<T> = {
  onReceiveVerificationData: OnReceiveVerificationDataCallback<T>;
  onReceiveSuccess: OnReceiveSuccessCallback;
  onReceiveError: OnReceiveErrorCallback;
};

export function useElectronicIdHub<T extends ElectronicIdHubData>(
  subscriber: UseElectronicIdHubSubscriber<T>,
) {
  const hubService = useMemo(() => {
    const instance = ServicesProvider.getSingleton<
      IElectronicIdHubService<AudkenniAppHubData>
    >(ElectronicIdHubServiceToken);
    instance.start();
    return instance;
  }, []);

  useEffect(() => {
    const listenerIds: string[] = [];
    listenerIds.push(
      hubService.on(
        ElectronicIdHubServiceEvents.ReceiveVerificationDataAsync,
        subscriber.onReceiveVerificationData,
      ),
    );

    listenerIds.push(
      hubService.on(
        ElectronicIdHubServiceEvents.ReceiveSuccessAsync,
        subscriber.onReceiveSuccess,
      ),
    );

    listenerIds.push(
      hubService.on(
        HubServiceEvents.ReceiveErrorAsync,
        subscriber.onReceiveError,
      ),
    );

    return () => {
      hubService.off(listenerIds);
    };
  }, [hubService, subscriber]);
}
